import { axiosInstance as axios } from "services";

export const deletePromotionalCode = async (id) => {
  const { data } = await axios.delete(`/admin/subscription/promotional-codes/${id}`);
  if (!data.success) throw new Error(data.error?.message || "Failed to delete promotional code");
  return data;
};

